export default __webpack_public_path__ + "static/media/Chinese-literature.c89a590c.svg";